import React, { Suspense, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import LandingHeader from './LandingHeader';
import LandingFooter from './LandingFooter';
import CookieConsent from '../../../components/common/CookieConsent';

const LandingLayout = () => {
    const location = useLocation();

    // Scroll to top automatically when location pathname changes
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    const isHome = location.pathname === '/';

    return (
        <div className="bg-background-light dark:bg-background-dark text-slate-900 dark:text-slate-100 font-display font-sans">
            <div className="relative flex min-h-screen flex-col overflow-x-hidden">
                <LandingHeader />
                <main className={`flex-1 ${!isHome ? 'pt-32' : ''}`}>
                    {/* Trang con tải lười: chỉ phần giữa chờ, header / footer giữ nguyên */}
                    <Suspense
                        fallback={
                            <div className="flex min-h-[50vh] items-center justify-center">
                                <div className="h-8 w-8 animate-spin rounded-full border-[3px] border-slate-200 border-t-orange-500" />
                            </div>
                        }>
                        <Outlet />
                    </Suspense>
                </main>
                <LandingFooter />
                <CookieConsent />
            </div>
        </div>
    );
};

export default LandingLayout;
